<script>
import { authComputed } from '@state/helpers'

export default {
  data() {
    return {
      persistentNavRoutes: [
        {
          name: 'home',
          title: 'Home',
        },
      ],
      loggedInNavRoutes: [
        {
          name: 'profile',
          title: () => 'Logged in as ' + this.currentUser.name,
        },
        {
          name: 'logout',
          title: 'Log out',
        },
      ],
      loggedOutNavRoutes: [
        {
          name: 'login',
          title: 'Log in',
        },
      ],
      techAssistantNavRoutes: [
        {
          name: 'technician-assistant',
          title: 'Job Lookup',
        },
      ],
    }
  },
  computed: {
    ...authComputed,
  },
}
</script>

<template>
  <ul :class="$style.container" class="mb-0">
    <span :class="$style.logo_container">
      <a id="link-brinks-logo-job-lookup" href="/"
        ><img
          :class="$style.logo"
          src="https://images.ctfassets.net/n58cc9djl3c5/4qnLpGNQJ95otSoIMqgY1S/15c4d5f12826eda7df0332f769e8ec84/logo-brinks-home-security-white.svg"
          alt="Logo"
      /></a>
    </span>
    <span :class="$style.link_container"> </span>
  </ul>
</template>

<style lang="scss" module>
@import '@design';

.container {
  padding: 0;
  margin: 0 0 $size-grid-padding;
  text-align: left;
  list-style-type: none;
  width: 100vw;
  z-index: 1000;
  height: $height-navbar;

  > li {
    display: inline-block;
    margin-right: $size-grid-padding;
  }
}

.logo {
  width: 10em;
  padding: 1em;
}

.logo_container {
  display: table-cell;
}

.link_container {
  display: table-cell;
  width: 95%;
  padding-right: 5%;
  text-align: right;
}
</style>
